import { ArrowDownTrayIcon } from '@heroicons/react/24/outline';
import axios from 'axios';
import { isEmpty } from 'radash';

import { Icon } from '@/components/core/Icon';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/core/Popover';
import { LOCAL_STORAGE } from '@/constants';
import { useToast } from '@/hooks/useToast';
import { useTranslation } from '@/hooks/useTranslation';
import { restUrl } from '@/services/utils';

import { Button } from '../core/Button';
import { useExportFormat } from './download-button.queries';
import FileTypeIcon from './FileTypeIcon';

const DownloadButton = ({
    selectedItems,
    startMappingEditor,
    startTemplateMappingSelector}
    : {
    selectedItems: string[],
    startMappingEditor: any,
    startTemplateMappingSelector:any
    })=> {
    const {t} = useTranslation();
    const { toast } = useToast();
    const lookupLanguage = localStorage.getItem(LOCAL_STORAGE.LANGUAGE_KEY);

    const {data: exportFormats} = useExportFormat();

    const downloadItems = async (exportType: any) => {
        if (!selectedItems || isEmpty(selectedItems)) {
            toast.warning('NO_ITEMS_SELECTED');
        } else if (exportType === 'template'){
            startTemplateMappingSelector();
        } else if (exportType.usesMapping || !isEmpty(exportType.attributes)) {
            startMappingEditor(selectedItems, exportType);
        } else {
            await axios.post<any>(restUrl('selections'), {
                primaryKeys: selectedItems
            }).then(async (response: any) => {
                const _selectionId = response.data.selectionId;
                await axios.get(
                    restUrl(`items/exports/${_selectionId}?language=${lookupLanguage ?? 'en'}&type=${exportType.contentType}`))
                    .then((_response) =>{
                        toast.success(t('ITEM.EXPORT_SUCCESS', {
                            link: '/exports'
                        }));
                    });
            });
        }
    };

    if (exportFormats) {
        return (
            <Popover>
                <PopoverTrigger asChild>
                    <Button variant='outline'>
                        <Icon icon={ArrowDownTrayIcon} size='sm' variant='secondary'/>
                        <span className='tw-p-1'>{t('DOWNLOAD_LABEL')}</span>
                    </Button>
                </PopoverTrigger>
                <PopoverContent className='tw-w-70'>
                    <ul className='tw-max-h-80 tw-h-fit tw-overflow-y-auto tw-border tw-border-gray-300 tw-list-none tw-p-0'>
                        {exportFormats.map((option: any, index: number) => (
                            <li key={index} className='tw-h-[40px]'>
                                <a className='tw-no-underline tw-text-black tw-flex tw-items-center' onClick={()=>downloadItems(option)}>
                                    <span className='tw-pr-2 tw-flex tw-items-center'>
                                        <FileTypeIcon fileType={option.icon || option.name}></FileTypeIcon>
                                    </span>
                                    <span>{option.name}</span>

                                </a>
                                {(index !== exportFormats.length -1 ) &&
                                <span className='tw-mt-2 tw-block tw-h-[1px] tw-bg-gray-300 tw-rounded-sm tw-w-full'></span>
                                }
                            </li>
                        ))}
                    </ul>

                </PopoverContent>
            </Popover>
        );
    }
};

export default DownloadButton;
